//images
import SiteIcon from '../images/internet.svg';
import AddressIcon from '../images/point.svg';
import WorkTimeIcon from '../images/clock.svg';
import PhoneIcon from '../images/phone.svg';
import EmailIcon from '../images/email.svg';

//types
import { IStoreItemProps } from '../types/IStoreItemProps';
import { getLangVar } from '../../../../util/misc';

export default function StoreItem({
    store,
}: IStoreItemProps){
    const site = store?.url ?? null;
    const name = getLangVar(store, 'name');
    const address = getLangVar(store, 'address');
    const workHours = getLangVar(store, 'workHours');
    const phone = getLangVar(store, 'phone');
    const email = getLangVar(store, 'email');

    return (
        <div className="stores-list__item store-item" key={store.id}>
            <div className="store-item__inner">
                <div className="store-item__name">{name}</div>
                {address ? (
                    <div className="store-item__address"> 
                        <img 
                            src={AddressIcon}
                            alt="icon"
                        />
                        {address}
                    </div>
                ) : null}
                {workHours ? (
                    <div className="store-item__worktime"> 
                        <img 
                            src={WorkTimeIcon}
                            alt="icon"
                        />
                        {workHours}
                    </div>
                ) : null}
                {phone ? (
                    <div className="store-item__phone"> 
                        <img 
                            src={PhoneIcon}
                            alt="icon"
                        />
                        {phone}
                    </div>
                ) : null}
                {site ? (
                    <div className="store-item__site"> 
                        <img 
                            src={SiteIcon}
                            alt="icon"
                        />
                        {site}
                    </div>
                ) : null}
                {email ? (
                    <div className="store-item__email"> 
                        <img 
                            src={EmailIcon}
                            alt="icon"
                        />
                        {email}
                    </div>
                ) : null}
            </div>
        </div>
    );
}